import { DEFAULT_PIEVE_REASONING_EFFORT } from './defaultModel.js';
import { PIEVE_MODEL_MAP, PIEVE_SENTINEL_MODELS } from './modelCatalog.js';
import { normalizePieveModelId } from './modelSelection.js';

const PIEVE_REASONING_EFFORT_ORDER = ['low', 'medium', 'high', 'xhigh', 'max'];

export const getPieveModelReasoningLevels = (modelId) => {
  const normalizedModelId = normalizePieveModelId(modelId);
  const reasoning = (PIEVE_SENTINEL_MODELS[normalizedModelId] || PIEVE_MODEL_MAP[normalizedModelId])?.support?.reasoning;

  if (reasoning?.enabled !== true) {
    return [];
  }

  return Array.isArray(reasoning.levels) ? reasoning.levels : [];
};

export const getDefaultPieveReasoningEffortForModel = (modelId) => {
  const levels = getPieveModelReasoningLevels(modelId);

  return levels.includes(DEFAULT_PIEVE_REASONING_EFFORT) ? DEFAULT_PIEVE_REASONING_EFFORT : levels[0] || '';
};

export const getClosestPieveReasoningEffortForModel = (modelId, reasoningEffort) => {
  const levels = getPieveModelReasoningLevels(modelId);

  if (levels.length === 0) {
    return '';
  }

  if (levels.includes(reasoningEffort)) {
    return reasoningEffort;
  }

  const targetIndex = PIEVE_REASONING_EFFORT_ORDER.indexOf(reasoningEffort);

  if (targetIndex === -1) {
    return getDefaultPieveReasoningEffortForModel(modelId);
  }

  return levels.reduce((closest, level) => {
    const closestIndex = PIEVE_REASONING_EFFORT_ORDER.indexOf(closest);
    const levelIndex = PIEVE_REASONING_EFFORT_ORDER.indexOf(level);
    const closestDistance = Math.abs(closestIndex - targetIndex);
    const levelDistance = Math.abs(levelIndex - targetIndex);

    if (levelDistance !== closestDistance) {
      return levelDistance < closestDistance ? level : closest;
    }

    return levelIndex > closestIndex ? level : closest;
  });
};
